export const filter = (query = '', obj) => {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.some((item) => filter(query, item));
    }
    if (obj === null) {
      return false;
    }
    return Object.values(obj).some((value) => filter(query, value));
  }

  if (['boolean', 'bigint', 'number', 'string'].includes(typeof obj)) {
    return String(obj).toLowerCase().includes(query.toLowerCase());
  }

  return false;
};
